export const appRoutesDefinitions = {
  login: {
    path: 'login',
    name: 'login'
  },
  loginCallback: {
    path: 'login/callback',
    name: 'loginCallback'
  },
  dashboard: {
    path: 'home',
    name: 'dashboardApp'
  },
  video: {
    path: 'video',
    name: 'videoApp'
  },
  text: {
    path: 'text',
    name: 'textApp'
  },
  courseContentReview: {
    path: 'course-content-review',
    name: 'courseContentReviewApp'
  },
  image: {
    path: 'image',
    name: 'imageApp'
  },
  results: {
    path: 'results',
    name: 'resultsApp'
  }
};
